// extracted by mini-css-extract-plugin
module.exports = {"tabs":"LayoutSettings_tabs__3lJrI","tabContainer":"LayoutSettings_tabContainer__1BKOi"};